import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Button } from 'primeng/button';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface ButtonFieldProps extends FormlyFieldProps {
  severity?: typeof Button.prototype.severity;
  variant?: typeof Button.prototype.variant;
  icon?: string;
  iconPos?: typeof Button.prototype.iconPos;
  onClick: any;
  link?: boolean;
  styleClass?: string;
}

@Component({
  selector: 'text-field',
  standalone: true,
  imports: [...FORM_IMPORTS, Button],
  template: `
    <p-button
      styleClass="{{
        props.styleClass ? props.styleClass : 'w-full'
      }} justify-start"
      [label]="props.label"
      [severity]="props.severity ?? 'primary'"
      [variant]="props.variant"
      [icon]="props.icon"
      [iconPos]="props.iconPos ?? 'left'"
      (onClick)="props.onClick(this)"
      [link]="props.link ?? false"
    >
    </p-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonFieldType extends FieldType<
  FieldTypeConfig<ButtonFieldProps>
> {}
